import { Failure } from '@geekbears/gb-ngrx-stack-base';
import { createAction, props } from '@ngrx/store';
import {
  GetRequestsActionResponse,
  RequestAction,
} from '../../domain/entities/request-type.entity';

/**
 * Actions For All Requests Type
 */
export const getAllRequestsTypeAction = createAction(
  '[Requests Type] Get All Requests Type Action'
);
export const getAllRequestsTypeSuccessAction = createAction(
  '[Requests Type] Get All Requests Type Success Action',
  props<{
    requestsType: GetRequestsActionResponse;
  }>()
);
export const getAllRequestsTypeFailureAction = createAction(
  '[Requests Type] Get All Requests Type Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Create Requests Type
 */
export const createRequestTypeAction = createAction(
  '[Requests Type] Create Request Type Action',
  props<{
    requestType: RequestAction;
  }>()
);
export const createRequestTypeSuccessAction = createAction(
  '[Requests Type] Create Request Type Success Action',
  props<{
    response: GetRequestsActionResponse;
  }>()
);
export const createRequestTypeFailureAction = createAction(
  '[Requests Type] Create Request Type Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Delete Requests Type
 */
export const deleteRequestTypeAction = createAction(
  '[Requests Type] Delete Request Type Action',
  props<{
    requestsTypeId: any;
  }>()
);
export const deleteRequestTypeSuccessAction = createAction(
  '[Requests Type] Delete Request Type Success Action',
  props<{
    response: any;
  }>()
);
export const deleteRequestTypeFailureAction = createAction(
  '[Requests Type] Delete Request Type Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Update Requests Type
 */
export const updateRequestTypeAction = createAction(
  '[Requests Type] Update Request Type Action',
  props<{
    id: string;
    action: string;
  }>()
);
export const updateRequestTypeSuccessAction = createAction(
  '[Requests Type] Update Request Type Success Action',
  props<{
    response: GetRequestsActionResponse;
  }>()
);
export const updateRequestTypeFailureAction = createAction(
  '[Requests Type] Update Request Type Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Get Request Actions By Company
 */
export const getRequestActionsByCompanyAction = createAction(
  '[Requests Type] Get Request Actions By Company Action',
  props<{
    companyId: string;
  }>()
);
export const getRequestActionsByCompanySuccessAction = createAction(
  '[Requests Type] Get Request Actions By Company Success Action',
  props<{
    response: GetRequestsActionResponse;
  }>()
);
export const getRequestActionsByCompanyFailureAction = createAction(
  '[Requests Type] Get Request Actions By Company Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Change Request Action Type
 */
export const changeRequestActionTypeAction = createAction(
  '[Requests Type] Change Request Action Type Action',
  props<{
    companyId: string;
    data: {
      approvalType: string;
    };
  }>()
);
export const changeRequestActionTypeSuccessAction = createAction(
  '[Requests Type] Change Request Action Type Success Action',
  props<{
    response: GetRequestsActionResponse;
  }>()
);
export const changeRequestActionTypeFailureAction = createAction(
  '[Requests Type] Change Request Action Type Failure Action',
  props<{
    failure: Failure;
  }>()
);

export const RequestsTypeActions = {
  /**
   * Actions For Get All Requests Type
   */
  getAllRequestsType: getAllRequestsTypeAction,
  getAllRequestsTypeSuccess: getAllRequestsTypeSuccessAction,
  getAllRequestsTypeFailure: getAllRequestsTypeFailureAction,

  /**
   * Actions For Create Request Type
   */
  createRequestType: createRequestTypeAction,
  createRequestTypeSuccess: createRequestTypeSuccessAction,
  createRequestTypeFailure: createRequestTypeFailureAction,

  /**
   * Actions For Delete Request Type
   */
  deleteRequestType: deleteRequestTypeAction,
  deleteRequestTypeSuccess: deleteRequestTypeSuccessAction,
  deleteRequestTypeFailure: deleteRequestTypeFailureAction,

  /**
   * Actions For Update Request Type
   */
  updateRequestType: updateRequestTypeAction,
  updateRequestTypeSuccess: updateRequestTypeSuccessAction,
  updateRequestTypeFailure: updateRequestTypeFailureAction,

  /**
   * Actions For Update Request Type
   */
  getRequestActionsByCompany: getRequestActionsByCompanyAction,
  getRequestActionsByCompanySuccess: getRequestActionsByCompanySuccessAction,
  getRequestActionsByCompanyFailure: getRequestActionsByCompanyFailureAction,

  /**
   * Actions For Change Request Action Type
   */
  changeRequestActionType: changeRequestActionTypeAction,
  changeRequestActionTypeSuccess: changeRequestActionTypeSuccessAction,
  changeRequestActionTypeFailure: changeRequestActionTypeFailureAction,
};
